export default function CreateAccountLight() {
  return (
    <>
      <button className="btn btn-light uppercase font-bold lg:capitalize lg:font-light">
        Create Account
      </button>
    </>
  )
}
